import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconSettingsWrench from './nav-icon-settings-wrench.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconSettingsWrench {...validProps} />;
}
SvgComponent.iconName = 'navIconSettingsWrench';

/**
 * @deprecated This is a legacy icon
 */
export const NavIconSettingsWrenchIcon = svgIconWrapper(SvgComponent);
